var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"pt-2"},[_c('tabs',{staticClass:"border-bottom mb-3",attrs:{"tabs":_vm.rutas}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }